import VideosShowTemplate from "../../handlebars/templates/videos/show.hbs"

class @App.Components.VideoPreview
  constructor: (element) ->
    @container = $('#modalShowVideo .better-modal-contents')
    @attributes = {}

    $(document).on 'App::Components::VideoSearch::search_submit', (e) =>
      @container.empty().hide()

    $(document).on 'click', '.better-modal-pager-prev', (e) ->
      prev_url = $(event.target).data('prev-url')
      prev_grid_item = $("div[data-url='" + prev_url + "']")
      modal = $('.better-modal')
      modal.data('close-button-added', 'false')
      modal.data('paging-buttons-added', 'false')
      prev_grid_item.click()

    $(document).on 'click', '.better-modal-pager-next', (e) ->
      next_url = $(event.target).data('next-url')
      next_grid_item = $("div[data-url='" + next_url + "']")
      modal = $('.better-modal')
      modal.data('close-button-added', 'false')
      modal.data('paging-buttons-added', 'false')
      next_grid_item.click()

  hide: =>
    @container.hide()
    $(document).trigger 'App::Components::VideoPreview::hide'

  show: (attributes) =>
    @container.html('')
    @container.show()

    $(document).trigger
      type: 'App::Components::VideoPreview::show'
      text: 'Loading'

    $.getJSON attributes.url, (data) =>
      content = VideosShowTemplate(
        $.extend(
          {},
          data.video,
          { form_authenticity_token: attributes.form_authenticity_token }
        )
      )
      @container.append(content)

      $('.better-modal-contents .better-modal-pager-prev')
        .attr('data-prev-url', attributes.prev_url)
      $('.better-modal-contents .better-modal-pager-next')
        .attr('data-next-url', attributes.next_url)

      $(document).trigger 'App::Components::VideoPreview::shown'
      @container.find('input[type="submit"]').focus()
